var animationDuration = {
  fastest: 120,
  standard: 300,
  slower: 450,
  double: 600
};

export { animationDuration };
